// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"create-list-modal_modalFooter__6lP01"};